import {Component, OnInit} from '@angular/core';
import {provideNativeDateAdapter} from '@angular/material/core';
import {BusinessService} from '../../_service/business.service';
import {Business} from '../../models/business.model';
import {HibernateData} from '../../models/hibernate-data.model';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'app-hibernate-cancel',
  standalone: false,
  providers: [provideNativeDateAdapter()],
  templateUrl: './hibernate-cancel.component.html',
  styleUrl: './hibernate-cancel.component.css',
})
export class HibernateCancelComponent implements OnInit {
  configList: any;
  business: Business;
  hibernating: boolean = false;
  hibernateModel: HibernateData = new HibernateData();
  noHibernationDate: boolean = false;
  noHibernationReason: boolean = false;
  tomorrow: Date = new Date();
  // hibernate form
  hibernateDate = new FormControl();
  hibernateReason = new FormControl();


  constructor(private businessService: BusinessService) {
    this.business = businessService.getBusiness();
    this.configList = this.businessService.getConfigList();
  }

  ngOnInit() {
    this.tomorrow.setDate(this.tomorrow.getDate() + 1);
    this.noHibernationReason = false;
    this.noHibernationDate = false;
  }

  hibernateAccount() {
    if (!this.hibernateModel.date || this.hibernateModel.date === '') {
      this.noHibernationDate = true;
    } else {
      this.noHibernationDate = false;
    }
    if (!this.hibernateModel.reason || this.hibernateModel.reason === '') {
      this.noHibernationReason = true;
    } else {
      this.noHibernationReason = false;
    }

    if (!this.noHibernationDate && !this.noHibernationReason) {
      this.hibernating = true;
      this.businessService.hibernateAccount(this.hibernateModel).subscribe(value => {
        this.hibernating = false;
      });
    }
  }

  cancelAccount() {

  }

}
